<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Add video')"
        v-bind:is-open="isOpen"
        v-on:close-modal="closeModal"
        v-bind:slot-props="errors"
        v-bind:key="key"
    >
        <template v-slot:body>
            <p class="has-margin-b15">
                <strong
                    v-html="__('Supported formats: MOV, MP4, OGG, WEBM')"
                ></strong>
            </p>
            <div class="has-margin-b30">
                <control
                    name="titleAddControl"
                    type="text"
                    v-bind:label="__('Title')"
                    v-model="addedVideo.title"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.title != null"
                >
                    {{ errors.title[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    name="orientationAddControl"
                    type="select"
                    v-bind:label="__('Orientation')"
                    v-model="addedVideo.orientation"
                    v-bind:options="orientations"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.orientation != null"
                >
                    {{ errors.orientation[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    name="fileAddControl"
                    type="file"
                    ref="addFileControl"
                    v-bind:label="__('File')"
                    v-model="addedVideo.file"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.video != null"
                >
                    {{ errors.video[0] }}
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <btn
                class="is-block is-success"
                type="default"
                v-html="__('Save')"
                v-on:click="createVideo"
            ></btn>
        </template>
    </modal>
</template>

<script>
import { Btn, Control, Modal } from '@teamfurther/cinderblock';
import videoConfig from '../../../config/videoConfig';
import StringService from '../../../services/StringService';

export default {
    components: {
        Btn,
        Control,
        Modal
    },
    computed: {
        orientations: function() {
            return videoConfig.orientations.map(item => {
                return {
                    label: StringService.capitalize(item),
                    value: item
                };
            });
        }
    },
    data: function() {
        return {
            addedVideo: {
                file: null,
                title: '',
                name: '',
                orientation: 'horizontal'
            },
            key: 0
        };
    },
    methods: {
        createVideo: function() {
            this.addedVideo.name = this.$refs.addFileControl.selectedFilename;

            this.$emit('create', this.addedVideo);
        },
        closeModal: function() {
            this.$emit('close');
        },
        clearData: function() {
            this.addedVideo = {
                file: null,
                title: '',
                name: ''
            };

            this.$refs.addFileControl.selectedFilename = null;
            this.$refs.addFileControl.selectedFile = null;

            this.key++;
        }
    },
    props: {
        errors: {
            required: true
        },
        isOpen: {
            required: true
        }
    },
    watch: {
        isOpen: function() {
            this.clearData();
        }
    }
};
</script>
